import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { AuthProvider } from "./context/AuthContext";
import SmoothScroll from "./components/SmoothScroll";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Portal from "./pages/Portal";
import Flyer from "./pages/Flyer";
import Admin from "./pages/Admin";
import AdminRoute from "./components/AdminRoute";
import Simulator from "./pages/Simulator";
import Enroll from "./pages/Enroll";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <SmoothScroll>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/flyer" element={<Flyer />} />
                            <Route path="/simulator" element={<Simulator />} />
                            <Route path="/enroll" element={<Enroll />} />
                            <Route path="/payment/success" element={<PaymentSuccess />} />
                            <Route path="/payment/cancel" element={<PaymentCancel />} />
                            <Route
                                path="/portal"
                                element={
                                    <ProtectedRoute>
                                        <Portal />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <AdminRoute>
                                        <Admin />
                                    </AdminRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <Admin />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </SmoothScroll>
                    <Toaster
                        position="top-right"
                        toastOptions={{
                            style: {
                                borderRadius: 0,
                                fontFamily: "IBM Plex Mono, monospace",
                                fontSize: 12,
                                border: "1px solid hsl(var(--border))",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
